import { useState } from "react";
import { Check, Loader2, User, Users } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const PLANS = [
  {
    key: "single", name: "Single", price: "24.00", icon: User, seats: "1 provider",
    features: ["Unlimited AI SOAP notes", "Note polishing & voice dictation", "Client goals & progress graphs", "PDF export"],
  },
  {
    key: "group", name: "Group", price: "100.00", icon: Users, seats: "Up to 7 members", highlight: true,
    features: ["Everything in Single, for 7 people", "Invite your RBTs & BCBAs by link", "Add or remove members anytime", "One bill for the whole team"],
  },
];

export function PlanCards({ disabled }) {
  const [busy, setBusy] = useState("");
  const subscribe = async (plan) => {
    setBusy(plan);
    try {
      const { data } = await api.post("/payments/checkout", { plan, origin_url: window.location.origin });
      window.location.assign(data.checkout_url);
    } catch (e) { toast.error(errMsg(e)); setBusy(""); }
  };
  return (
    <div className="grid md:grid-cols-2 gap-5 stagger">
      {PLANS.map((p) => (
        <div key={p.key} className={`relative rounded-2xl border p-7 bg-white ${p.highlight ? "border-primary shadow-md" : ""}`} data-testid={`plan-card-${p.key}`}>
          {p.highlight && <span className="absolute -top-3 left-7 text-[11px] font-semibold px-3 py-1 rounded-full bg-amber-500 text-slate-900">Best value · ~$14 per person</span>}
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-secondary text-primary grid place-items-center"><p.icon className="h-5 w-5" /></div>
            <div>
              <div className="font-display font-semibold text-lg">{p.name}</div>
              <div className="text-xs text-slate-500">{p.seats}</div>
            </div>
          </div>
          <div className="mt-6 flex items-baseline gap-1">
            <span className="text-4xl font-display font-bold" data-testid={`plan-price-${p.key}`}>${p.price}</span>
            <span className="text-slate-500 text-sm">/ month</span>
          </div>
          <ul className="mt-6 space-y-2.5">
            {p.features.map((f) => <li key={f} className="flex items-start gap-2 text-sm text-slate-700"><Check className="h-4 w-4 text-emerald-600 mt-0.5 shrink-0" />{f}</li>)}
          </ul>
          <Button className={`mt-7 w-full rounded-full h-11 ${p.highlight ? "" : "bg-slate-900 hover:bg-slate-800"}`} disabled={disabled || !!busy} onClick={() => subscribe(p.key)} data-testid={`subscribe-${p.key}-button`}>
            {busy === p.key && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Choose {p.name}
          </Button>
        </div>
      ))}
    </div>
  );
}
